import { Link } from "react-router-dom";
import { episodes } from "@/mocks/episodes";
import SectionHeader from "@/components/base/SectionHeader";
import Tag from "@/components/base/Tag";

export default function LatestEpisodes() {
  const maxSeason = Math.max(...episodes.map((e) => e.season));
  const latest = episodes.filter((e) => e.season === maxSeason).slice(0, 4);

  return (
    <section aria-label="最新章节" className="mt-12 md:mt-16">
      <SectionHeader
        eyebrow="Latest Episodes"
        title={`第 ${maxSeason} 季 · 关键剧情章节`}
        subtitle="最终季剧情已推进至高潮，点击任意章节查看剧情概述、关键解析与出演阵容。"
        action={
          <Link
            to="/episodes"
            className="inline-flex items-center gap-2 text-sm font-label text-accent-400 hover:text-accent-300 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部章节
            <i className="ri-arrow-right-line" />
          </Link>
        }
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 md:gap-5">
        {latest.map((ep) => (
          <Link
            key={ep.id}
            to={`/episodes/${ep.id}`}
            className="group flex flex-col rounded-lg overflow-hidden bg-background-100 border border-background-200 hover:border-accent-500/40 transition-colors cursor-pointer"
          >
            <div className="relative w-full h-40 overflow-hidden">
              <img
                src={ep.cover}
                alt={`${ep.title} 剧照`}
                title={`${ep.title} - 美国禁忌4 第 ${ep.season} 季第 ${ep.episodeNumber} 集`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <span className="absolute top-3 left-3 rounded-full bg-background-50/85 backdrop-blur px-2.5 py-1 text-[11px] font-label tracking-wide text-foreground-900">
                S{ep.season} · E{ep.episodeNumber}
              </span>
            </div>
            <div className="flex flex-col flex-1 p-4">
              <h3 className="font-heading text-base text-foreground-950 group-hover:text-accent-400 transition-colors">
                {ep.title}
              </h3>
              <p className="mt-2 text-[13px] text-foreground-500 leading-relaxed line-clamp-3">{ep.summary}</p>
              <div className="mt-4 pt-3 border-t border-background-200 flex items-center justify-between">
                <Tag tone="secondary">
                  <i className="ri-calendar-line mr-1" />
                  {ep.airDate}
                </Tag>
                <span className="flex items-center gap-1 text-xs text-accent-400 font-label">
                  <i className="ri-star-fill" />
                  {ep.rating}
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}